import React from "react";
import {Route} from "react-router-dom";


const module = (shopApp) => {
	const ShippingCosts = shopApp.dynamic(() => import("./ShippingCosts"));

	const url = "/shipping_costs";

	let config = {
		name: "ShippingCosts",
		routes: [
			<Route key={url} exact path={url} component={ShippingCosts}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
